/* eslint-disable import/no-anonymous-default-export */
export default {
	title: 'Dark',

	colors: {
		primary: '#14132d',
		secondary: '#0099ad',

		background: '#050716',
		text: '#f7f7f7'
	}
}
